// extracted by css-extract-rspack-plugin
export default {"section":"_c80887c9","header":"_b70a2e5f"};